module.exports = __webpack_public_path__ + "static/abside-circle-icon-6879e05a365ad51a454204710cd189ba.svg";